import PropTypes from 'prop-types'

import styles from './TitledBox.module.css'

export const TitledBox = ({ children, className, error, titulo }) => {
  return (
    <div className={`${className || ''} ${styles.container} ${error ? styles.errorContainer : ''}`}>
      {error && <div className={styles.error}>{error}</div>}
      <span className={styles.titulo}>{titulo}</span>
      {children}
    </div>
  )
}

TitledBox.propTypes = {
  titulo: PropTypes.node.isRequired,
  className: PropTypes.string,
  error: PropTypes.string,
  children: PropTypes.node.isRequired
}
